import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMitsubishiComponent } from './simple-icons-mitsubishi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMitsubishiComponent ],
    exports:      [ SimpleIconsMitsubishiComponent ],
    bootstrap:    []
})
export class SimpleIconsMitsubishiModule {}
